import { createI18n } from 'vue-i18n'
import english from './english'

const i18n = new createI18n({
    legacy: false,
    locale: "en",
    fallbackLocale: "en",
    messages: {
        "en": english
    }
});

export default i18n